import { render, staticRenderFns } from "./wxxiangqingCheck.vue?vue&type=template&id=31355bfe&scoped=true"
import script from "./wxxiangqingCheck.vue?vue&type=script&lang=js"
export * from "./wxxiangqingCheck.vue?vue&type=script&lang=js"
import style0 from "./wxxiangqingCheck.vue?vue&type=style&index=0&id=31355bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31355bfe",
  null
  
)

export default component.exports